<script>

    import { PrepaidStore } from '../stores'
    
    import Modal from '../$components/modal.svelte'
    import Prepaids from '../prepaids/prepaids.svelte'
    import PrepaidRead from '../prepaids/prepaid.svelte'

</script>

<Prepaids />

<Modal id="PrepaidRead" title="Información prepago" >
    <PrepaidRead on:deleted={PrepaidStore.modalClose} />
</Modal>